import React from 'react';
import classNames from 'classnames';
import { CommentCountCompact } from '../../../comments/components/comment-count-compact';
import { Counter } from '../counter';
import { type CounterProps } from '../counter/counter';
import { SkeletonRenderer } from '../skeleton-renderer';
import ViewCount from '../view-count';
import ViewCountCompact from '../view-count-compact';
import styles from './post-stats.scss';

type Props = {
  displayIcons: boolean;
  className?: string;
  isMetadataLoaded: boolean;
  showViewCount?: boolean;
  showCommentCount?: boolean;
  postCommentsDisabled: boolean;
  views: number;
  comments: number;
};

export const PostStats = ({
  displayIcons,
  className,
  isMetadataLoaded,
  showViewCount = true,
  showCommentCount = true,
  postCommentsDisabled,
  views,
  comments,
}: Props) => {
  const Views = displayIcons ? ViewCountCompact : ViewCount;
  const Count = displayIcons
    ? CommentCountCompact
    : (props: CounterProps) => <Counter i18nKey="comment-count.label" {...props} />;
  const showCommentStats = showCommentCount && (comments > 0 || !postCommentsDisabled);

  return (
    <div className={classNames(styles.container, 'post-stats', className)} data-hook="post-stats">
      {showViewCount && (
        <SkeletonRenderer isLoaded={isMetadataLoaded} width={30}>
          <Views count={views} className={className} />
        </SkeletonRenderer>
      )}
      {showCommentStats && (
        <SkeletonRenderer isLoaded={isMetadataLoaded} width={30}>
          <Count showZero count={comments} className={className} />
        </SkeletonRenderer>
      )}
    </div>
  );
};
